/**
 * Validation Modal Manager - Handles validation messages modal functionality
 */
export class ValidationModalManager {
    constructor() {
        this.MODAL_ID = 'validationMessagesModal';
        this.modal = null;
        this.dismissEndpoint = '';
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeModal();
            });
        }
        else {
            this.initializeModal();
        }
    }
    initializeModal() {
        const validationModal = document.getElementById(this.MODAL_ID);
        if (!validationModal) {
            return;
        }
        // Get dismiss endpoint from data attribute
        this.dismissEndpoint = validationModal.getAttribute('data-dismiss-endpoint') || '';
        // Initialize Bootstrap modal
        if (window.bootstrap?.Modal) {
            this.modal = new window.bootstrap.Modal(validationModal);
            this.modal.show();
        }
        // Setup dismiss buttons
        this.setupDismissButtons();
        // Setup checkboxes
        this.setupDismissCheckboxes();
    }
    setupDismissButtons() {
        const dismissButtons = document.querySelectorAll('.dismiss-btn');
        dismissButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                const target = event.currentTarget;
                const dismissId = target.getAttribute('data-dismiss-id');
                if (dismissId) {
                    const checkbox = document.querySelector(`.dismiss-checkbox-input[data-message-id="${dismissId}"]`);
                    const permanentlyDismiss = checkbox ? checkbox.checked : false;
                    this.dismissValidationMessage(dismissId, permanentlyDismiss);
                }
            });
        });
    }
    setupDismissCheckboxes() {
        const checkboxes = document.querySelectorAll('.dismiss-checkbox-input');
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', (event) => {
                const target = event.currentTarget;
                if (target.checked) {
                    const messageId = target.getAttribute('data-message-id');
                    if (messageId) {
                        this.dismissValidationMessage(messageId, true);
                    }
                }
            });
        });
    }
    dismissValidationMessage(messageId, permanently) {
        const messageElement = document.querySelector(`.validation-message-item[data-message-id="${messageId}"]`);
        if (permanently) {
            // Send request to mark as dismissed
            this.sendDismissRequest(messageId);
        }
        // Remove from DOM with CSS animation
        if (messageElement) {
            messageElement.classList.add('dismissing');
            setTimeout(() => {
                messageElement.remove();
                // Check if there are more messages and close modal if none
                this.checkAndCloseModal();
            }, 300);
        }
    }
    sendDismissRequest(messageId) {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        fetch(this.dismissEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-CSRF-TOKEN': csrfToken || ''
            },
            body: `message_id=${messageId}`
        }).catch((error) => {
            console.error('Error al descartar mensaje:', error);
        });
    }
    checkAndCloseModal() {
        const remainingMessages = document.querySelectorAll('.validation-message-item');
        if (remainingMessages.length === 0 && this.modal) {
            this.modal.hide();
        }
    }
    /**
     * Programmatically show the validation modal
     */
    showModal() {
        if (!this.modal) {
            const validationModal = document.getElementById(this.MODAL_ID);
            if (validationModal && window.bootstrap?.Modal) {
                this.modal = new window.bootstrap.Modal(validationModal);
            }
        }
        if (this.modal) {
            this.modal.show();
        }
    }
    /**
     * Programmatically hide the validation modal
     */
    hideModal() {
        if (this.modal) {
            this.modal.hide();
        }
    }
}
export default ValidationModalManager;
